import React, {useEffect, useState} from 'react';
import ReactDOM from "react-dom/client";
import queryString from 'query-string';
import useFetchData from './fetcher';
import FilterSearch from './filter-search';
import BlogFilters from './blog-filters';
import Pagination from './pagination';
import LoadingAnimation from './loading-animation';
import NoResults from './no-results';

import './scss/blog-index.scss';


const BlogIndexApp = (props) => {
  const langcode = (drupalSettings.path.currentLanguage == 'en') ? '/' : '/' + drupalSettings.path.currentLanguage + '/';
  const fetchUrl = langcode + 'rest-api/cp-blog-index-data';
  const [fetch, setFetch] = useState(fetchUrl);
  const [filters, setFilters] = useState({search: '', industry: '', state: ''});
  const [isReady, setIsReady] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Grab the search and filters from the query string on the first run.
    const parsed = queryString.parse(location.hash);

    setFilters(parsed);

    setIsReady(true);
  }, []);

  // Fetch data from the rest resource.
  useEffect(() => {
    if (isReady) {
      useFetchData(fetch, setData, setLoading);
    }
  }, [fetch]);

  // Build the fetch url based on search and filters.
  useEffect(() => {
    setLoading(true);
    if (isReady) {
      // Update browser hash with the current filters and set new fetch url.
      location.hash = queryString.stringify(filters);
      setFetch(`${fetchUrl}?${queryString.stringify(filters)}`);
    }
  }, [filters]);

  const scrollTop = () => {
    // Scroll to top of the app. 
    const appDiv = document.getElementsByClassName(props.appDiv)[0];
    window.scrollTo({
      top: appDiv.offsetTop + 40,
      behavior: "smooth"
    });
  }

  return (
    <>
      {loading && <LoadingAnimation />}
      {(!loading) && (

            <div className='filters'>
              <BlogFilters dataFilters={data.filters} setFilters={setFilters} filters={filters} isReady={isReady} />
            </div>
      )}

      {/* List Blog posts. */}
      <div className='list' id="blog-list-wrapper">
        <div className="blog-list">
          {(!loading) && (
            <div className='search'>
              <h4 className="hide">{Drupal.t('Looking for something specific?')}</h4>
              <FilterSearch filters={filters} isReady={isReady} loading={loading} list={data.blog_posts} pagination={data.pagination} setFilters={setFilters} searchFor={Drupal.t('Blog Posts')} />
            </div>
          )}

        {(!loading && data.blog_posts && data.filters) && (
          <div className='blog-post-list'>
            {(data.blog_posts.length > 0) ? data.blog_posts.map((item, i) => (
              <a key={i} className="body" href={item.node_alias}>
                <img src={item.image} alt={item.title} className='blog_thumb_image' loading='lazy' />
                <div className="blog-info">
                  <h4 className='title'>{item.title}</h4>
                  <div className="text-muted mb50">
                    <span className='author'>{item.author_name}</span>
                    <span className='separator'>|</span>
                    <span className='category'>{item.category_name}</span>
                  </div>
                  <p className="read-more mt20">{Drupal.t('Read more')}</p>
                </div>

              </a>
            )) : (
              <NoResults setFilters={setFilters} />
            )}
          </div>
        )}

        {/* Pagination */}
        {(!loading && data.pagination && data.pagination.pages > 1) && (
          <Pagination pagination={data.pagination} setFilters={setFilters} filters={filters} isReady={isReady} scrollTop={scrollTop} />
        )}
      </div>
      </div>
    </>
  );
};

const appDiv ='cp-blog-index-app';
const appRoot = document.querySelectorAll(`.${appDiv}`);
appRoot.forEach((element) => {
  const root = ReactDOM.createRoot(element);
  root.render(
    <React.StrictMode>
      <BlogIndexApp appDiv={appDiv} />
    </React.StrictMode>
  );
});
